import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import React from "react";

interface UserState {
  data: any;
  ShowUserData: any;
  editUserData:any;
  loading: boolean;
  error: string;
  EditRow: number | string;
}
const initialState: UserState = {
  data: [],
  ShowUserData: [],
  editUserData:[],
  loading: false,
  error: "",
  EditRow: 0,
};

export const AddUserInUserManagement = createAsyncThunk(
  "adduser",
  async (data: any, thunkAPI) => {
    try {
      const response = await axios.post("api", data);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err || "error");
    }
  }
);
export const GetUserDataInUserManagement = createAsyncThunk(
  "showdata",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get("/apidata");
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err || "error");
    }
  }
);
export const EditUserData = createAsyncThunk(
  "editUser",
  async (data: any, thunkAPI) => {
    try {
      const response = await axios.put("ap", data);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err || "error");
    }
  }
);
export const SaveUserData=createAsyncThunk('saveUser',async(data,thunkAPI)=>{
  try{
const response=await axios.post('/api',data)
return response;
  } catch (err) {
      return thunkAPI.rejectWithValue(err || "error");
    }
})
const UserManagementSlice = createSlice({
  name: "UserManagementSlice",
  initialState,
  reducers: {
    setEditRow: (state, action) => {
      state.EditRow = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AddUserInUserManagement.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUserInUserManagement.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(AddUserInUserManagement.rejected, (state) => {
        state.loading = false;
      })
      .addCase(GetUserDataInUserManagement.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetUserDataInUserManagement.fulfilled, (state, action) => {
        state.ShowUserData = action.payload;
        state.loading = false;
      })
      .addCase(GetUserDataInUserManagement.rejected, (state) => {
        state.loading = false;
      })
      .addCase(EditUserData.pending, (state) => {
        state.loading = true;
      })
      .addCase(EditUserData.fulfilled, (state, action) => {
        state.editUserData = action.payload;
        state.loading = false;
      })
      .addCase(EditUserData.rejected, (state) => {
        state.loading = false;
      });
  },
});
export const { setEditRow } = UserManagementSlice.actions;
export default UserManagementSlice.reducer;
